import { chartColors } from '../../theme';

const formatBRL = (v) => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });

// Opções base para os gráficos (Chart.js): marcas finas, grade discreta,
// sem legenda para série única (o título do card nomeia a série).
export const baseChartOptions = ({ horizontal = false, onClick, legend = false, currency = false, stacked = false } = {}) => {
    const valueAxis = horizontal ? 'x' : 'y';
    const tickFont = { family: 'Inter', size: 11 };
    // Só define `callback` no eixo de valores em R$: passar `callback: undefined`
    // anula o formatador padrão do Chart.js e o eixo de categorias passa a exibir índices.
    const ticks = (eixo, padding) => ({
        color: chartColors.axis,
        font: tickFont,
        padding,
        precision: 0,
        ...(currency && eixo === valueAxis ? { callback: (v) => formatBRL(v), maxTicksLimit: 5, maxRotation: 0 } : {}),
    });

    return {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: horizontal ? 'y' : 'x',
        onClick,
        onHover: onClick
            ? (event, elements) => {
                const target = event?.native?.target;
                if (target) target.style.cursor = elements.length ? 'pointer' : 'default';
            }
            : undefined,
        interaction: { mode: 'index', intersect: false },
        plugins: {
            legend: legend
                ? {
                    display: true,
                    position: 'top',
                    align: 'end',
                    labels: { font: { family: 'Inter', size: 12 }, color: chartColors.axis, boxWidth: 10, boxHeight: 10, useBorderRadius: true, borderRadius: 2 },
                }
                : { display: false },
            title: { display: false },
            tooltip: {
                backgroundColor: '#101828',
                titleFont: { family: 'Inter', size: 12, weight: '600' },
                bodyFont: { family: 'Inter', size: 12 },
                padding: 10,
                cornerRadius: 6,
                displayColors: legend,
                boxPadding: 4,
                ...(currency
                    ? { callbacks: { label: (ctx) => `${ctx.dataset.label}: ${Number(horizontal ? ctx.parsed.x : ctx.parsed.y).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}` } }
                    : {}),
            },
        },
        scales: {
            x: {
                stacked,
                grid: { display: horizontal, color: chartColors.grid, drawTicks: false },
                border: { display: false },
                ticks: ticks('x', 6),
                beginAtZero: true,
            },
            y: {
                stacked,
                grid: { display: !horizontal, color: chartColors.grid, drawTicks: false },
                border: { display: false },
                ticks: ticks('y', 8),
                beginAtZero: true,
            },
        },
    };
};

export const barDataset = (label, data, color = chartColors.primary) => ({
    label,
    data,
    backgroundColor: color,
    borderRadius: 4,
    borderSkipped: 'start',
    maxBarThickness: 36,
});

export const lineDataset = (label, data, color = chartColors.primary) => ({
    label,
    data,
    borderColor: color,
    backgroundColor: 'rgba(27, 175, 122, 0.08)',
    borderWidth: 2,
    pointRadius: 3,
    pointHoverRadius: 5,
    pointBackgroundColor: color,
    fill: true,
    tension: 0.3,
});
